import React, { useEffect, useState } from 'react';
import './App.css';
import { getCachedToken } from "./auth/auth";
import { getRoleFromJWTToken } from './repo/notificationRepo';
import Routes from './Routes';
import MaintenanceModal from './components/MaintenanceModal';
import { onMaintenanceMode } from './api/axios';
import api from './api/axios';

function App() {
  console.disableYellowBox = true;
  const isMobile = window.innerWidth <= 500;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [role, setRole] = useState(undefined);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [maintenanceInfo, setMaintenanceInfo] = useState(null);
  const [isRetrying, setIsRetrying] = useState(false);

  useEffect(() => {
    getCachedToken();
    if (!isMobile) {
      setIsDrawerOpen(true);
    }

    let cachedRole = getRoleFromJWTToken();
    setRole("guest");
    if (!role && cachedRole) {
      setRole(cachedRole);
      console.log(">>>" + cachedRole);
    }

    // Subscribe to maintenance mode events
    const unsubscribe = onMaintenanceMode((info) => {
      setMaintenanceMode(true);
      setMaintenanceInfo(info);
    });

    // Cleanup subscription on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      // Make a simple API call to check if maintenance mode is over
      // Using the /health endpoint as a lightweight check
      await api.get('/health');

      // If successful, maintenance mode is over
      setMaintenanceMode(false);
      setMaintenanceInfo(null);

      // Reload the page to refresh all data
      window.location.reload();
    } catch (error) {
      // If still in maintenance mode (503), the interceptor will handle it
      // If it's a different error (401, 404, etc.), maintenance mode is likely over
      if (error.response && error.response.status !== 503) {
        setMaintenanceMode(false);
        setMaintenanceInfo(null);
        window.location.reload();
      }
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <div className="App">
      <Routes
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        role={role}
        setRole={setRole}
      />
      <MaintenanceModal
        open={maintenanceMode}
        maintenanceInfo={maintenanceInfo}
        onRetry={handleRetry}
        isRetrying={isRetrying}
      />
    </div>
  );
}

export default App;
